module.exports = __webpack_public_path__ + "img/supervisor-intro-four.1d189880.png";